import i18n from '@/i18n';
import { promotions } from '@/utils/permission';
import { PREFIX } from '@/utils/constants';
const Layout = () => import('@/layouts/main.vue');
const Promotions = () => import('./views/Index.vue');
const PromotionView = () => import('./views/PromotionView.vue');

export default [
  {
    path: 'promotions',
    component: Layout,
    meta: { authRequired: true, header: true },
    children: [
      {
        path: '',
        name: `${PREFIX.INSPECTOR}.Promotions`,
        component: Promotions,
        meta: {
          title: i18n.global.t('promotions.promotions'),
          permission: { module: promotions.module, key: promotions.showAll },
        },
      },
      {
        path: 'view/:id?',
        name: `${PREFIX.INSPECTOR}.Promotions.View`,
        component: PromotionView,
        meta: {
          title: i18n.global.t('promotions.view'),
          pageType: 'view',
          permission: { module: promotions.module, key: promotions.showOne },
        },
        props: true,
      },
      {
        path: 'create',
        name: `${PREFIX.INSPECTOR}.Promotions.Create`,
        component: PromotionView,
        meta: {
          title: i18n.global.t('promotions.create'),
          pageType: 'create',
          permission: { module: promotions.module, key: promotions.create },
        },
      },
      {
        path: 'update/:id?',
        name: `${PREFIX.INSPECTOR}.Promotions.Update`,
        meta: {
          title: i18n.global.t('promotions.update'),
          pageType: 'update',
          permission: { module: promotions.module, key: promotions.update },
        },
        component: PromotionView,
        props: true,
      },
    ],
  },
];
